import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ButtonDirective } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BD_PERMISSION_FORBIDDEN_PATH } from '../guard.const';

export interface BdPermissionGuardDialogData {
  message: string;
  permissionsToCheck: string[];
}

@Component({
  template: `
    <div class="flex flex-row gap-6 items-center">
      <div>
        <i class="pi pi-lock" style="font-size: 3.5rem"></i>
      </div>

      <p-divider layout="vertical" />

      <div class="flex-1">
        <div class="flex flex-col gap-2">
          <span class="text-sm text-muted-color">Zugang gesperrt</span>

          <span class="text-lg font-semibold">{{ message }}</span>

          <span
            >Wenden Sie sich bitte an useren
            <a [href]="hrefPath">Support</a> für weitere Hilfe</span
          >
        </div>
      </div>
    </div>

    <div class="flex justify-end mt-6">
      <button
        pButton
        [outlined]="true"
        severity="secondary"
        (click)="ref.close()"
      >
        Schließen
      </button>
    </div>
  `,

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ButtonDirective, DividerModule],
})
export class BdPermissionGuardDialogComponent {
  public readonly ref = inject(DynamicDialogRef);
  public readonly hrefPath = BD_PERMISSION_FORBIDDEN_PATH;

  private readonly _config =
    inject<DynamicDialogConfig<BdPermissionGuardDialogData>>(
      DynamicDialogConfig,
    );

  public readonly message =
    this._config.data?.message ??
    'Sie haben nicht die erforderten Berechtigungen !';
}
